import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { Toaster } from "sonner";

import "./styles/index.css";

import { router } from "./router";
import { queryClient } from "./lib/queryClient";
import { bootstrapTheme } from "./lib/theme";

bootstrapTheme();

const rootEl = document.getElementById("root");
if (!rootEl) {
    throw new Error("#root element missing from index.html");
}

createRoot(rootEl).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
            <Toaster
                richColors
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "var(--color-surface-raised)",
                        color: "var(--color-text)",
                        border: "1px solid var(--color-border)",
                    },
                }}
            />
        </QueryClientProvider>
    </StrictMode>,
);
